import React from 'react'
import api, { METHODS } from './api'
import getReport from './getReport'
import { reportValidator, translateErrorBackendMessages } from './helper'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'
import { ResponseType } from '../common/types/api/request'


export default async function publishReport(uid: string): Promise<ResponseType> {
    const reportCheck = reportValidator(await getReport(uid))

    // if not fields to fix remain, then try to publish report
    if (!reportCheck.length) {
        try {
            const res = await api<ResponseType>('publish/' + `${uid}`, METHODS.POST, '')
            if (res.error) {
                GlobalNotification.error(
                    <Notification title={i18n('Error trying to publish report: ')}>
                        {translateErrorBackendMessages(res.error)}
                    </Notification>,
                    20
                )

                console.error(res)

                return {
                    success: false,
                    error: res.error
                }
            }else {
                GlobalNotification.success(<Notification title={i18n('Report published successfully!')} />, 20)
            }

            return res // success
        } catch (error) {
            GlobalNotification.error(
                <Notification title={i18n('Error trying to publish report: ')}>{error.error || error.message}</Notification>,
                20
            )

            console.error(error)

            return {
                success: false,
                error: error
            }
        }
    } else {
        GlobalNotification.error(
            <Notification title={i18n('The following fields are missing:')}>
                {reportCheck.map((field, index) => (
                    <tr key={index}>
                        <strong>* </strong>
                        {field}
                    </tr>
                ))}
            </Notification>,
            20
        )
        console.error(i18n('error publishing the report. front-end validation result is: '), reportCheck)

        return { success: false, error: i18n('there are fields missing') }
    }
}
